.a2{width:100%;}